import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=245a2562&scoped=true&"
import script from "./Load.vue?vue&type=script&lang=ts&"
export * from "./Load.vue?vue&type=script&lang=ts&"
import style0 from "./Load.vue?vue&type=style&index=0&id=245a2562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a2562",
  null
  
)

export default component.exports